import React from 'react';
import Layout from '../../../layouts/index';
import EditModal from '../components/modal/EditModal';
import { useTranslation } from 'react-i18next';

const EditSufferer = () => {
    const { t } = useTranslation();
    
    return (
        <Layout>
            <div className='space-y-5'>
                <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('sufferer.editTitle')}</h1>
                <EditModal t={t} />
            </div>
        </Layout>
    );
};

export default EditSufferer;
